
import React from 'react';

export default function LeatherEducation() {
  const topics = [
    {
      icon: 'ri-truck-line',
      title: 'HYUNDAI H100 / PORTER',
      description:
        '포터 쉐조레 99, H100 시리즈 전용 부품. 헤드램프, 포그램프, 테일램프, 범퍼, 그릴, 미러, 핸들, 펜더, 패널 등 외장 부품 총 40종 이상 보유. 순정 규격 완벽 호환.',
      link: '/shop',
    },
    {
      icon: 'ri-roadster-line',
      title: 'HYUNDAI HD / TRAGO',
      description:
        'HD35, HD45, HD65, HD72, HD78 및 트라고 HD170, HD260 시리즈. 헤드램프, 코너램프, 포그램프, 그릴, 범퍼, 사이드스텝, 미러, 도어패널 등 120종 이상의 상용차 전용 부품.',
      link: '/shop',
    },
    {
      icon: 'ri-car-line',
      title: 'KIA BONGO 3 / K3000',
      description:
        '봉고3 12~22년식, K3000 프론티어, K2500, K2700 전용 부품. 헤드램프, LED 포그램프, 크롬 그릴, LED 그릴, 미러, 후드, 범퍼, 에어필터 등 70종 이상 완비.',
      link: '/shop',
    },
    {
      icon: 'ri-bus-line',
      title: 'STAREX / COUNTY / 버스',
      description:
        '스타렉스 H1, 카운티 버스, 유니버스 전용 부품. 헤드램프, 테일램프, 포그램프, 그릴, 미러, 펜더, 후드, 범퍼 등 다양한 승합·버스 전용 부품 40종 이상 보유.',
      link: '/shop',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'GLOW PLUG (글로우 플러그)',
      description:
        '디젤 엔진 필수 부품. 프론티어, 테라칸, 갤로퍼, 쏘렌토, 봉고3, 마이티2, 산타페, 포터2, 그랜드 스타렉스, 싼타페TM 등 다양한 차종 지원. 11V/4.4V 규격.',
      link: '/shop',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'DAEWOO / 소음기 밴드',
      description:
        '대우 다마스, 티코, 마티즈, 에스페로, 레간자 전용 램프류와 트럭용 소음기 반도/벤딩. 트라고, 메가트럭, 파비스, E마이티, E카운티 등 상용차 배기 부품.',
      link: '/shop',
    },
  ];

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-[#F8F9FA] relative">
      {/* Background Texture Image */}
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://public.readdy.ai/ai/img_res/0c98336294bd4e264dd43d0aed0d6cc8.jpg"
          alt="배경 텍스처"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-[1400px] mx-auto px-4 md:px-8 relative z-10">
        <div className="text-center mb-10 md:mb-16 lg:mb-20">
          <div className="mb-3 md:mb-6">
            <span
              className="text-[#E63946] text-xs md:text-sm tracking-[0.3em] font-bold"
              style={{ fontFamily: "'Anton', sans-serif" }}
            >
              PARTS CATEGORY
            </span>
          </div>

          <h2
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#1A1A2E] mb-4 md:mb-6 leading-tight"
            style={{ fontFamily: "'Anton', sans-serif" }}
          >
            부품 가이드
          </h2>

          <p
            className="text-sm md:text-base text-[#4A4A5A] max-w-2xl mx-auto"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            현대 · 기아 · 대우 차종별 전문 부품을 카테고리별로 확인하세요
          </p>
        </div>

        {/* Topics Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8 mb-10 md:mb-16">
          {topics.map((topic, index) => (
            <a
              key={index}
              href={topic.link}
              className="bg-white p-5 md:p-7 lg:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 rounded-lg cursor-pointer group"
            >
              {/* Icon */}
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mb-4 md:mb-6 bg-[#1A1A2E] rounded-lg group-hover:bg-[#E63946] transition-colors duration-300">
                <i className={`${topic.icon} text-2xl md:text-3xl text-white`}></i>
              </div>

              {/* Title */}
              <h3
                className="text-base md:text-lg font-bold text-[#1A1A2E] mb-2 md:mb-4 tracking-wide"
                style={{ fontFamily: "'Anton', sans-serif" }}
              >
                {topic.title}
              </h3>

              {/* Description */}
              <p
                className="text-[#4A4A5A] leading-relaxed text-xs md:text-sm"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {topic.description}
              </p>

              {/* Decorative Line */}
              <div className="mt-4 md:mt-6 h-1 w-12 md:w-16 bg-[#E63946] group-hover:w-full transition-all duration-500"></div>
            </a>
          ))}
        </div>

        {/* Large Auto Parts Images */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 lg:gap-8 mb-10 md:mb-16">
          <div className="relative h-[220px] sm:h-[280px] md:h-[320px] overflow-hidden shadow-xl rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=Hyundai%20commercial%20truck%20headlamp%20assembly%20clear%20lens%20chrome%20housing%20professional%20automotive%20lighting%20product%20photography%20on%20dark%20background%20dramatic%20studio%20lighting%20high%20quality%20detailed%20shot&width=600&height=600&seq=guide-hyundai-lamp01&orientation=squarish"
              alt="현대 트럭 헤드램프"
              className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 md:p-6">
              <p className="text-white text-sm md:text-lg font-bold" style={{ fontFamily: "'Inter', sans-serif" }}>
                현대 트럭 램프
              </p>
            </div>
          </div>

          <div className="relative h-[220px] sm:h-[280px] md:h-[320px] overflow-hidden shadow-xl rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=Kia%20Bongo%20truck%20front%20grille%20and%20headlamp%20exterior%20parts%20professional%20automotive%20product%20photography%20on%20dark%20background%20dramatic%20studio%20lighting%20high%20quality%20detailed%20shot&width=600&height=600&seq=guide-kia-bongo01&orientation=squarish"
              alt="기아 봉고 부품"
              className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 md:p-6">
              <p className="text-white text-sm md:text-lg font-bold" style={{ fontFamily: "'Inter', sans-serif" }}>
                기아 봉고 부품
              </p>
            </div>
          </div>

          <div className="relative h-[220px] sm:h-[280px] md:h-[320px] overflow-hidden shadow-xl rounded-lg sm:col-span-2 md:col-span-1">
            <img
              src="https://readdy.ai/api/search-image?query=diesel%20engine%20glow%20plug%20and%20truck%20exhaust%20muffler%20band%20automotive%20parts%20collection%20professional%20product%20photography%20on%20dark%20background%20dramatic%20studio%20lighting%20high%20quality%20detailed%20shot&width=600&height=600&seq=guide-glowplug-muffler01&orientation=squarish"
              alt="글로우 플러그 & 소음기 밴드"
              className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 md:p-6">
              <p className="text-white text-sm md:text-lg font-bold" style={{ fontFamily: "'Inter', sans-serif" }}>
                글로우 플러그 & 소음기
              </p>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <a
            href="/shop"
            className="inline-flex items-center gap-2 md:gap-3 text-[#1A1A2E] font-bold text-sm md:text-lg hover:text-[#E63946] transition-colors cursor-pointer"
            style={{ fontFamily: "'Anton', sans-serif" }}
          >
            <span>전체 부품 카탈로그 보기</span>
            <i className="ri-arrow-right-line text-lg md:text-2xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
